import React from 'react'
import type { ToolCategory } from '../config/tools'

// ── Types ─────────────────────────────────────────────────────────────────────

interface CategoryBadgeProps {
  category: ToolCategory
  size?: 'sm' | 'xs'
}

// ── Colour map ────────────────────────────────────────────────────────────────

const CATEGORY_COLOURS: Record<ToolCategory, string> = {
  'Formatters':       'bg-blue-900/40 text-blue-300',
  'Encoders/Decoders':'bg-violet-900/40 text-violet-300',
  'Generators':       'bg-emerald-900/40 text-emerald-300',
  'Converters':       'bg-amber-900/40 text-amber-300',
  'Validators':       'bg-rose-900/40 text-rose-300',
  'Network Tools':    'bg-cyan-900/40 text-cyan-300',
}

// ── Component ─────────────────────────────────────────────────────────────────

const CategoryBadge: React.FC<CategoryBadgeProps> = ({ category, size = 'sm' }) => {
  const colours = CATEGORY_COLOURS[category] ?? 'bg-neutral-800 text-neutral-400'

  const sizeClass = size === 'xs'
    ? 'px-1.5 py-0.5 text-[9px]'
    : 'px-2 py-0.5 text-[10px]'

  return (
    <span
      className={[
        'inline-flex items-center rounded font-semibold uppercase tracking-wide',
        sizeClass,
        colours,
      ].join(' ')}
    >
      {category}
    </span>
  )
}

export default CategoryBadge
